// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_jTX","cls2":"common-cls2_IHd common-cls1_jTX"};